var map = {
	"./about/competitive_dna.svg": "5a74",
	"./about/flexible_agile.svg": "8823",
	"./about/high_performance.svg": "8968",
	"./about/ideas.svg": "6907",
	"./about/immense_experience.svg": "6c78",
	"./about/industry_insights.svg": "90d4",
	"./about/our_team.svg": "c656",
	"./about/perks.svg": "4cfe",
	"./about/real_time_support.svg": "6ec3",
	"./career/perks/bike.svg": "8a4e",
	"./career/perks/environment.svg": "9bb7",
	"./career/perks/lithuania.svg": "3869",
	"./career/perks/merch.svg": "e751",
	"./career/perks/offices.svg": "0d0d",
	"./career/perks/own_ideas.svg": "f5b6",
	"./career/perks/parties.svg": "6922",
	"./career/perks/real_experts.svg": "6861",
	"./career/perks/schedule.svg": "ca3a",
	"./career/perks/snacks.svg": "8579",
	"./career/perks/start_up.svg": "3478",
	"./career/perks/training.svg": "d286",
	"./career/perks/wallet.svg": "f4cd",
	"./career/stack/RabbitMQ.svg": "c97f",
	"./career/stack/TiDB.svg": "970a",
	"./career/stack/angular.svg": "43e5",
	"./career/stack/go.svg": "b75e",
	"./career/stack/influxDB.svg": "f538",
	"./career/stack/js.svg": "9a38",
	"./career/stack/mariaDB.svg": "247c",
	"./career/stack/react.svg": "4c91",
	"./career/stack/ts.svg": "394e",
	"./career/stack/vue.svg": "fb2f",
	"./contacts/1.jpeg": "4b7d",
	"./contacts/1_thumb.jpg": "f676",
	"./contacts/2.jpeg": "b868",
	"./contacts/2_thumb.jpg": "8b58",
	"./contacts/3.jpeg": "792f",
	"./contacts/3_thumb.jpg": "79a9",
	"./contacts/4.jpeg": "38a0",
	"./contacts/4_thumb.jpg": "42d0",
	"./contacts/5.jpeg": "4157",
	"./contacts/5_thumb.jpg": "15aa",
	"./contacts/6.jpeg": "04d2",
	"./contacts/6_thumb.jpg": "feb7",
	"./direction_ico.svg": "7eb2",
	"./exhibitions/IceAfrica.png": "8d8a",
	"./exhibitions/IceLondon.png": "22b5",
	"./exhibitions/betgames-logo.svg": "74b4",
	"./exhibitions/gallery/1.jpeg": "2d5e",
	"./exhibitions/gallery/1_thumb.jpg": "530b",
	"./exhibitions/gallery/2.jpeg": "d914",
	"./exhibitions/gallery/2_thumb.jpg": "4d92",
	"./exhibitions/gallery/3.jpg": "51a9",
	"./exhibitions/gallery/3_thumb.jpg": "e5de",
	"./exhibitions/gallery/4.jpg": "5633",
	"./exhibitions/gallery/4_thumb.jpg": "74b8",
	"./exhibitions/gallery/5.jpeg": "f359",
	"./exhibitions/gallery/5_thumb.jpg": "c5aa",
	"./exhibitions/gallery/6.jpg": "0501",
	"./exhibitions/gallery/6_thumb.jpg": "6e70",
	"./exhibitions/gallery/7.jpg": "744a",
	"./exhibitions/gallery/7_thumb.jpg": "a328",
	"./exhibitions/gallery/8.jpg": "bf15",
	"./exhibitions/gallery/8_thumb.jpg": "5246",
	"./exhibitions/ice_london.png": "fa21",
	"./exhibitions/ice_london_2024.png": "fd8b",
	"./exhibitions/meet_us_london.png": "40f8",
	"./exhibitions/meet_us_london_2022.png": "b387",
	"./exhibitions/meet_us_vln.jpg": "578b",
	"./home/avatar.svg": "e0b0",
	"./home/calendar.svg": "7484",
	"./home/clients.svg": "cb71",
	"./home/launch_time.svg": "65e6",
	"./home/online_solution.svg": "a91b",
	"./home/retail_solution.svg": "340b",
	"./home/satisfaction.svg": "06d1",
	"./home/support.svg": "f750",
	"./home/transactions.svg": "cc3a",
	"./home/whatsapp.svg": "2c6b",
	"./home/white_label.svg": "94a7",
	"./partners/agt.svg": "5be4",
	"./partners/amatic.svg": "b976",
	"./partners/arc.svg": "4836",
	"./partners/betdata.svg": "61cb",
	"./partners/betgames.svg": "f464",
	"./partners/betradar.svg": "fdb3",
	"./partners/evolution.svg": "6a7e",
	"./partners/globalbet.svg": "204b",
	"./partners/habanero.svg": "02c6",
	"./partners/kiron.svg": "ab63",
	"./partners/pragmatic.svg": "880c",
	"./partners/sis.svg": "16c7",
	"./partners/tvmanager.svg": "da05",
	"./people/akvile.png": "4de8",
	"./people/algirdas.png": "3713",
	"./people/anton.png": "16b5",
	"./people/karolis.png": "e0a1",
	"./people/marijus.png": "2b90",
	"./people/nerijus.png": "9548",
	"./people/ovidijus.png": "b8b1",
	"./people/sarunas.png": "1a9f",
	"./people/simas.png": "7ad6",
	"./people/toma.png": "5702",
	"./people/ugne.png": "2c58",
	"./people/zilva.png": "904b",
	"./products/games/betgames_online.png": "8f2c",
	"./products/games/betgames_retail.png": "b8e2",
	"./products/games/greyhounds_online.png": "472f",
	"./products/games/greyhounds_retail.png": "7986",
	"./products/games/horses_online.png": "7544",
	"./products/games/horses_retail.png": "8b54",
	"./products/games/keno_online.png": "acd3",
	"./products/games/keno_retail.png": "b9b9",
	"./products/games/lotto_online.png": "8457",
	"./products/games/lotto_retail.png": "4b24",
	"./products/games/roulette_online.png": "2cfa",
	"./products/games/roulette_retail.png": "968d",
	"./products/games/slots_online-1.png": "27d9",
	"./products/games/slots_online.png": "076e",
	"./products/games/sports_online.png": "0af3",
	"./products/games/sports_retail.png": "145f",
	"./products/games/vf_retail-1.png": "cfc3",
	"./products/games/vf_retail-2.png": "5452",
	"./products/games/vf_retail.png": "7171",
	"./products/icons/betgames.svg": "d54c",
	"./products/icons/greyhounds.svg": "78db",
	"./products/icons/horses.svg": "bd0b",
	"./products/icons/keno.svg": "ec74",
	"./products/icons/lotto.svg": "c0d7",
	"./products/icons/roulette.svg": "2ee9",
	"./products/icons/slots.svg": "83d3",
	"./products/icons/sports.svg": "aa45",
	"./products/icons/virtual_football.svg": "669a",
	"./slides/about/1.jpg": "3dcb",
	"./slides/about/2.jpg": "f6bc",
	"./slides/about/3.jpg": "e2fc",
	"./slides/about/4.jpg": "b039",
	"./slides/career/1.jpg": "1044",
	"./slides/career/2.jpg": "8874",
	"./slides/career/3.jpg": "7091",
	"./slides/career/4.jpg": "5a35",
	"./slides/career/5.jpg": "4b65",
	"./slides/home/1.jpg": "cc1e",
	"./slides/home/2.jpg": "3845",
	"./slides/home/3.jpg": "af01",
	"./slides/home/4.jpg": "938d",
	"./slides/position/slide.png": "9a14",
	"./slides/products/1.jpg": "6222",
	"./slides/products/2.jpg": "30bc",
	"./slides/products/3.jpg": "f099",
	"./slides/products/4.jpg": "7508",
	"./slides/solutions/1.jpg": "6063",
	"./slides/solutions/2.jpg": "70bc",
	"./slides/solutions/3.jpg": "3010",
	"./slides/solutions/4.jpg": "48be",
	"./social/facebook.svg": "0985",
	"./social/instagram.svg": "5469",
	"./social/linkedin.svg": "dbc9",
	"./social/linkedin_blue.svg": "7e07",
	"./social/twitter.svg": "3ce2",
	"./social/whatsapp.svg": "6d26"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";